"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomApiTransformUtil = void 0;
const GlobalAdapter_1 = require("../../../../api/GlobalAdapter");
const StoryNodeDisplayType_1 = require("../../../../storyV2/domain/StoryNodeDisplayType");
const GlobalClient_1 = require("../../../../cutil/GlobalClient");
const CustomApiTransformError_1 = require("../../../../storyV2/response/customApiHandler/error/CustomApiTransformError");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
const JsonUtil_1 = require("../../../../cutil/JsonUtil");
const LangUtil_1 = require("../../../../cutil/LangUtil");
class CustomApiTransformUtil {
    static isUploadFileType(displayType) {
        return this.uploadFileTypes.includes(displayType);
    }
    static getDisplayTypeByHeaders(headers) {
        const nodeDisplayType = this.getNodeDisplayTypeByHeaders(headers);
        if (nodeDisplayType) {
            return nodeDisplayType;
        }
        const contentType = headers?.get("Content-Type");
        if (contentType) {
            for (const [key, _displayType] of this.mimeTypesMap) {
                const regex = new RegExp(`^${key}`);
                if (regex.test(contentType)) {
                    const _displayType = this.mimeTypesMap.get(key);
                    if (!_displayType) {
                        continue;
                    }
                    return _displayType;
                }
            }
        }
        return StoryNodeDisplayType_1.StoryNodeDisplayType.TEXT;
    }
    static getNodeDisplayTypeByHeaders(headers) {
        const nodeType = headers?.get(GlobalAdapter_1.GlobalAdapterUtil.customApiNodeTypeHeaderName);
        if (nodeType) {
            const _nodeDisplayType = this.nodeTypesMap.get(nodeType);
            if (_nodeDisplayType) {
                return _nodeDisplayType;
            }
        }
        return undefined;
    }
    static async getBlobResult(request, url) {
        const displayType = request.displayType;
        /// 只处理 upload file type
        if (!CustomApiTransformUtil.isUploadFileType(displayType)) {
            return undefined;
        }
        const blob = await this.fetchBlob(request);
        if (!blob) {
            /// 如果是文件类型，但是不能回去文件类容
            throw CustomApiTransformError_1.CustomApiTransformError.default;
        }
        const initCreateBlobUrl = {
            objectURL: URL.createObjectURL(blob),
            loading: false,
            streaming: true,
        };
        const textAreaValue = {
            loading: false,
            s3Url: url,
            s3Path: "",
            // TODO need to refactor
            needToCreateBlobUrl: `/api/me/upload/studios?url=${encodeURIComponent(url)}`,
            uuid: "",
            name: "",
            format: "",
            value: url,
        };
        return { initCreateBlobUrl, textAreaValue, displayType: displayType };
    }
    static async fetchBlob(request) {
        switch (request.displayType) {
            case StoryNodeDisplayType_1.StoryNodeDisplayType.UPLOADIMAGE:
            case StoryNodeDisplayType_1.StoryNodeDisplayType.AUDIO:
            case StoryNodeDisplayType_1.StoryNodeDisplayType.BASEVIDEO:
            case StoryNodeDisplayType_1.StoryNodeDisplayType.PDFFILE:
                return await request.blob();
            case StoryNodeDisplayType_1.StoryNodeDisplayType.HTML:
                if (!(0, is_blank_1.default)(request.websocketHtml)) {
                    return new Blob([request.websocketHtml], { type: "text/html" });
                }
                else {
                    return await request.blob();
                }
        }
        return undefined;
    }
    /**
     * 返回类型application/json 并且 response.data.response 有值，那么需要取response 来显示，并且displatype作为text
     * @param displayType
     * @param res
     */
    static async resetDisplayType(displayType, res) {
        if (displayType === StoryNodeDisplayType_1.StoryNodeDisplayType.JSON && res instanceof GlobalClient_1.GlobalResponse) {
            const result = (await (0, LangUtil_1.tryPromise)(res.text())).data;
            const json = JsonUtil_1.JsonUtil.parse(result);
            if (json && !(0, is_blank_1.default)(json.data?.response)) {
                return StoryNodeDisplayType_1.StoryNodeDisplayType.TEXT;
            }
        }
        return displayType;
    }
}
exports.CustomApiTransformUtil = CustomApiTransformUtil;
CustomApiTransformUtil.uploadFileTypes = [
    StoryNodeDisplayType_1.StoryNodeDisplayType.UPLOADIMAGE,
    StoryNodeDisplayType_1.StoryNodeDisplayType.BASEVIDEO,
    StoryNodeDisplayType_1.StoryNodeDisplayType.AUDIO,
    StoryNodeDisplayType_1.StoryNodeDisplayType.PDFFILE,
    StoryNodeDisplayType_1.StoryNodeDisplayType.TABLE,
    StoryNodeDisplayType_1.StoryNodeDisplayType.HTML,
    StoryNodeDisplayType_1.StoryNodeDisplayType.UPLOADFILE,
];
CustomApiTransformUtil.nodeTypesMap = new Map([
    ["uploadImage", StoryNodeDisplayType_1.StoryNodeDisplayType.UPLOADIMAGE],
    ["baseVideo", StoryNodeDisplayType_1.StoryNodeDisplayType.BASEVIDEO],
    ["audio", StoryNodeDisplayType_1.StoryNodeDisplayType.AUDIO],
    ["pdfFile", StoryNodeDisplayType_1.StoryNodeDisplayType.PDFFILE],
    ["table", StoryNodeDisplayType_1.StoryNodeDisplayType.TABLE],
    ["html", StoryNodeDisplayType_1.StoryNodeDisplayType.HTML],
    ["askBrain", StoryNodeDisplayType_1.StoryNodeDisplayType.ASKBRAIN],
]);
CustomApiTransformUtil.mimeTypesMap = new Map([
    ["image/", StoryNodeDisplayType_1.StoryNodeDisplayType.UPLOADIMAGE],
    ["video/", StoryNodeDisplayType_1.StoryNodeDisplayType.BASEVIDEO],
    ["audio/", StoryNodeDisplayType_1.StoryNodeDisplayType.AUDIO],
    ["application/pdf", StoryNodeDisplayType_1.StoryNodeDisplayType.PDFFILE],
    ["text/csv", StoryNodeDisplayType_1.StoryNodeDisplayType.TABLE],
    ["application/vnd.ms-excel", StoryNodeDisplayType_1.StoryNodeDisplayType.TABLE],
    ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", StoryNodeDisplayType_1.StoryNodeDisplayType.TABLE],
    ["application/json", StoryNodeDisplayType_1.StoryNodeDisplayType.JSON],
    ["text/html", StoryNodeDisplayType_1.StoryNodeDisplayType.HTML],
    ["text/plain", StoryNodeDisplayType_1.StoryNodeDisplayType.TEXT],
]);
